export const getMarkerImage = () => '/images/site/maps/white-pin.svg';

export const getCommunityMarkerImage = (community) => {
    return getMarkerImage();
};

export const communityPopovercontent = (community) => {
    return `
        <div class="community-flyout__logo">
            <img alt="${community.name} logo" src="${community.logo}">
        </div>
    `;
}; 


// WEBPACK FOOTER //
// ./resources/components/helpers/mapHelpers.js